import AssistantContentRenderer from "duck/ui/chat/components/renderers/AssistantContentRenderer";
import {
  AssistantMessage,
  AssistantMessageContent,
  ChatMessage,
} from "duck/ui/chat/types";
import Box from "@mui/material/Box";

interface Props {
  message: ChatMessage;
  isStreaming: boolean;
}

// The intermediate_output tool's argument is shaped as AssistantMessage
// ({ messages: AssistantMessageContent[] }). It streams in via JSON-patch
// ops on message.content, so partial state is already structured by the
// time we render — no parsing needed.
const IntermediateOutputMessage = ({ message, isStreaming }: Props) => {
  const payload = message.content as
    { messages?: AssistantMessageContent[] } | null | undefined;
  const content: AssistantMessage = {
    messages: (payload?.messages ?? []).filter(Boolean),
  };

  return (
    <Box
      className="w-full flex justify-start"
      data-testid="intermediate-output"
    >
      <Box className="w-full py-0.5 text-left text-gray-700">
        <AssistantContentRenderer
          content={content}
          isStreaming={isStreaming}
          message={message}
        />
      </Box>
    </Box>
  );
};

export default IntermediateOutputMessage;
